import type {
  CanvasElementFrom,
  IoConfig,
  PropsOf,
  VisibilityElementProps,
  WithIoConfig,
  WithProps,
} from '@blaze-runtime/engine-domain';
import { type PropertiesConfig } from '@blaze-shared/elements-domain';

import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';
import { registerElementDefinition } from '../../services/element-definitions.service';
import { propsConfigHelper as epc } from '../../utils/elements-props-config.helpers';

import { PageBreakComponent } from './page-break.component';

// Extend the CanvasElementDefinitions type
declare module '@blaze-runtime/engine-domain' {
  interface CanvasElementDefinitions {
    pageBreak: PageBreakDef;
  }
}

type PageBreakPropsModel = VisibilityElementProps;

export type PageBreakDef = WithProps<PageBreakPropsModel> & WithIoConfig;
export type PageBreakElement = CanvasElementFrom<'pageBreak'>;

export function getPageBreakDefinition(): CanvasElementDefinition<'pageBreak'> {
  return {
    type: 'pageBreak',
    componentType: PageBreakComponent,
    isListed: true,
    name: 'Page Break',
    width: {
      mode: 'full',
    },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig(),
    defaults: getDefaults(),
    groups: ['most popular'],
    tags: ['print', 'pdf', 'page', 'break', 'new page'],
    version: 1,
  };
}

registerElementDefinition(getPageBreakDefinition());

function getIoConfig(): IoConfig {
  return {
    inputs: [
      {
        name: 'visible',
        bindingDefs: [{ property: 'visible', label: 'Is Visible', dataType: 'Boolean' }],
      },
    ],
  };
}

function getDefaults(): PropsOf<'pageBreak'> {
  return {
    content: {},
  };
}

function getPropsConfig(): PropertiesConfig {
  return epc.initConfig('pageBreak', [
    epc.section('content', 'Content', [epc.subsections.visibilitySubsection()]),
  ]);
}
